import {
    selectSpraySchemaEntityTypeName,
    selectFertilizerEntityTypeId,
    selectFertilizerSchemaInnerEntityTypeId,
    selectFertilizerSchemaInnerEntityTypePluralName,
    selectSpraySchemaEntityTypeId,
    selectSpraySchemaInnerEntityTypeId,
    selectSpraySchemaInnerEntityTypePluralName,
    selectFertilizerSchemaEntityTypeName
} from 'services/schemas/selectors';
import {
    APPLICATION_RATE_FILTER_TYPE,
    DATE_RANGE_FILTER_TYPE,
    ENTITIES_FILTER_TYPE,
    EQUIPMENT_FILTER_TYPE,
    INNER_ENTITIES_FILTER_TYPE,
    PRODUCT_FILTER_TYPE,
    SPRAY_EVENTS_NAMESPACE
} from 'services/sprayEvents/constants';
import { AppState } from 'services/types';
import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import {
    FERTILIZER_DATE_RANGE_FILTER_TYPE,
    FERTILIZER_ENTITIES_FILTER_TYPE,
    FERTILIZER_EVENTS_NAMESPACE,
    FERTILIZER_INNER_ENTITIES_FILTER_TYPE,
    FERTILIZER_PRODUCT_FILTER_TYPE
} from 'services/fertilizerEvents/constants';
import { Props } from '.';

const selectNamespace = (_state: AppState, props: Props): string | undefined =>
    props.namespace;

const spraySearchTypeOptions = createDeepEqualSelector(
    selectSpraySchemaInnerEntityTypePluralName,
    selectSpraySchemaEntityTypeName,
    (innerEntityTypeName, entityTypeName) => [
        {
            key: PRODUCT_FILTER_TYPE,
            text: 'Product',
            value: PRODUCT_FILTER_TYPE
        },
        {
            key: DATE_RANGE_FILTER_TYPE,
            text: 'Date Range',
            value: DATE_RANGE_FILTER_TYPE
        },
        {
            key: EQUIPMENT_FILTER_TYPE,
            text: 'Equipment Set',
            value: EQUIPMENT_FILTER_TYPE
        },
        {
            key: APPLICATION_RATE_FILTER_TYPE,
            text: 'Application Rate',
            value: APPLICATION_RATE_FILTER_TYPE
        },
        {
            key: ENTITIES_FILTER_TYPE,
            text: entityTypeName,
            value: ENTITIES_FILTER_TYPE
        },
        {
            key: INNER_ENTITIES_FILTER_TYPE,
            text: innerEntityTypeName,
            value: INNER_ENTITIES_FILTER_TYPE
        }
    ]
);

const fertilizerSearchTypeOptions = createDeepEqualSelector(
    selectFertilizerSchemaInnerEntityTypePluralName,
    selectFertilizerSchemaEntityTypeName,
    (innerEntityTypeName, entityTypeName) => [
        {
            key: FERTILIZER_PRODUCT_FILTER_TYPE,
            text: 'Product',
            value: FERTILIZER_PRODUCT_FILTER_TYPE
        },
        {
            key: FERTILIZER_DATE_RANGE_FILTER_TYPE,
            text: 'Date Range',
            value: FERTILIZER_DATE_RANGE_FILTER_TYPE
        },
        {
            key: FERTILIZER_ENTITIES_FILTER_TYPE,
            text: entityTypeName,
            value: FERTILIZER_ENTITIES_FILTER_TYPE
        },
        {
            key: FERTILIZER_INNER_ENTITIES_FILTER_TYPE,
            text: innerEntityTypeName,
            value: FERTILIZER_INNER_ENTITIES_FILTER_TYPE
        }
    ]
);

const searchTypeOptions = createDeepEqualSelector(
    selectNamespace,
    spraySearchTypeOptions,
    fertilizerSearchTypeOptions,
    (namespace, spraySearchOptions, fertilizerSearchOptions) => {
        switch (namespace) {
            case FERTILIZER_EVENTS_NAMESPACE:
                return fertilizerSearchOptions;
            case SPRAY_EVENTS_NAMESPACE:
            default:
                return spraySearchOptions;
        }
    }
);

const selectInnerEntityTypeId = createDeepEqualSelector(
    selectNamespace,
    selectSpraySchemaInnerEntityTypeId,
    selectFertilizerSchemaInnerEntityTypeId,
    (namespace, sprayInnerEntityTypeId, fertilizerInnerEntityTypeId) => {
        switch (namespace) {
            case FERTILIZER_EVENTS_NAMESPACE:
                return fertilizerInnerEntityTypeId;
            case SPRAY_EVENTS_NAMESPACE:
            default:
                return sprayInnerEntityTypeId;
        }
    }
);

const selectEntityTypeId = createDeepEqualSelector(
    selectNamespace,
    selectSpraySchemaEntityTypeId,
    selectFertilizerEntityTypeId,
    (namespace, sprayEntityTypeId, fertilizerEntityTypeId) => {
        switch (namespace) {
            case FERTILIZER_EVENTS_NAMESPACE:
                return fertilizerEntityTypeId;
            case SPRAY_EVENTS_NAMESPACE:
            default:
                return sprayEntityTypeId;
        }
    }
);

export {
    spraySearchTypeOptions,
    fertilizerSearchTypeOptions,
    searchTypeOptions,
    selectInnerEntityTypeId,
    selectEntityTypeId
};
